import { T, useGT } from 'gt-react';
import { Button } from 'src/components/ui/button';
import { bulkApplyToSelectedLinesLabel } from '../components/bulkApplyToSelectedLinesLabel';
import { overrideSectionPrimaryButtonKind } from './overrideSectionPrimaryButtonLabel';

export function OverrideSectionPrimaryButton({
  isSaving,
  bulkLineCount,
  canSubmit,
  onClick,
}: {
  isSaving: boolean;
  bulkLineCount: number;
  canSubmit: boolean;
  onClick: () => void;
}) {
  const gt = useGT();
  const kind = overrideSectionPrimaryButtonKind({ isSaving, bulkLineCount });

  return (
    <Button size="sm" onClick={onClick} disabled={!canSubmit}>
      {kind === 'saving' ? (
        <T context="override saving">Saving…</T>
      ) : kind === 'apply_bulk' ? (
        bulkApplyToSelectedLinesLabel(gt, bulkLineCount)
      ) : (
        <T context="override save">Save &amp; select</T>
      )}
    </Button>
  );
}
